import { render, staticRenderFns } from "./CaseSounds.vue?vue&type=template&id=077ca2af&scoped=true&"
import script from "./CaseSounds.vue?vue&type=script&lang=js&"
export * from "./CaseSounds.vue?vue&type=script&lang=js&"
import style0 from "./CaseSounds.vue?vue&type=style&index=0&id=077ca2af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077ca2af",
  null
  
)

export default component.exports